import IztTitleBar from './src/izt-title-bar'

IztTitleBar.install = Vue => {
  Vue.component(IztTitleBar.name, IztTitleBar)
}

export default IztTitleBar